import { Button, Card, Col, Table, Tag, Typography, Spin } from 'antd';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getAllAds } from '../../slices/ads/thunk';
import usecustomStyles from '../../Common/customStyles';
import { recentOrders } from '../../Common/data';
import DateService from '../../Services/DateService';
import Log from '../../Services/Log';
import { getStatus } from '../../Services/AdsStatusService';

const { Text } = Typography;

const customStyles = usecustomStyles();

const RecentOrder = () => {
    const dispatch = useDispatch();
    const [limit, setLimit] = useState(5);
    const adData = useSelector((state) => state.AllAds);
    const [adDataLength, setAdDataLength] = useState(0);
    const [viewAll , setViewAll] = useState(false);
    useEffect(() => {
        dispatch(getAllAds({ status: 'all', page: 1, limit: 250 }));
    }, []);

    const columns = [
        {
            title: 'Ad Id :',
            dataIndex: 'ad_id',
            render: (text) => <Link to={`/live-ads/${text}`} className='md'>{text}</Link>,
        },
        {
            title: 'Image',
            render: ({ ad_images }) => (
                <span className='ad_img red_shadow sm'>
                    {ad_images && ad_images[0]?.original ? (
                        <img src={ad_images[0].original} className='img_full cover' alt='' />
                    ) : (
                        <span>No Image</span>
                    )}
                </span>
            ),
        },
        {
            title: 'Clicks',
            dataIndex: 'total_clicks',
            render: (text) => <span className='md'>{text}</span>,
        },
        {
            title: 'Views',
            dataIndex: 'total_views',
            render: (text) => <span className='md'>{text}</span>,
        },
        {
            title: 'Plan',
            dataIndex: 'plan',
            render: (text) => <span className='md'>{text}</span>,
        },
        {
            title: 'Created Date',
            dataIndex: 'created_at',
            render: (text) => {
                const formattedDate = DateService.formatDateCustom(text);
                return <span className='md'>{formattedDate}</span>;
            },
        },
        {
            title: 'Due Date',
            dataIndex: 'end_date',
            render: (text) => {
                const formattedDate = DateService.formatDateCustom(text);
                return <span className='md'>{text ? formattedDate : ''}</span>;
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (text, record) => {
                const status = getStatus(text);
                const transactionStatus = record.transaction_status || 'No Transaction';
                return (
                    <span>{getStatus(text , transactionStatus)}</span>
                );
            },
        },
    ];

    useEffect(() => {
        setAdDataLength(adData?.ads?.length || 0);
    }, [adData]);


    useEffect(()=>{
        if(viewAll){
            setLimit(300);
        }
        else{
            setLimit(5)
        }
    },[viewAll])

    useEffect(()=>{
        console.log('limit' , limit)
    },[limit])

    return (
        <React.Fragment>
            {adData.loading && (
                <div className="spinner center">
                    <Spin />
                </div>
            )}
            {adData && (
                <Col className={'report_table'} xs={24} style={{ display: adDataLength > 0 ? 'block' : 'none' ,marginTop: customStyles.margin  } }  >
                    <Card className='recentCard'>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '24px', paddingLeft: '20px', paddingRight: '20px' }}>
                            <h4 className='text_md' style={{ marginBottom: '0', fontWeight: '500' }}>Report</h4>
                            { adData?.ads?.length > limit && (
                                  <Button type='primary' onClick={()=>{
                                    setViewAll((prev)=>!prev);
                                    
                                }}>
                                    {!viewAll ? 'View All' : 'View Less'}
                                </Button>
                            )}
                        </div>
                        {/* Table */}
                        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                            {
                                adData?.ads?.length > 0 && (
                           <Table
                                style={{ color: customStyles.colorTextLight }}
                                className='custom_table'
                                columns={columns}
                                dataSource={adData?.ads?.map((order, index) => {
                                    if (limit && index >= limit) {
                                        return null; // Return null for indexes greater than limit
                                    }
                                    return {
                                        ...order,
                                        key: index,
                                    };
                                }).filter(order => order !== null)}
                                pagination={false}
                            />
                                )
                            }
                            
                        </div>
                    </Card>
                </Col>
            )}
        </React.Fragment>
    );
}

export default RecentOrder;
